// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".finish-bottom {\n  position: fixed;\n  bottom: 0.68rem;\n  height: 1.12rem;\n  width: 100%;\n  border-top: 0.02rem solid #DCE1EA;\n  box-sizing: border-box;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.finish-bottom > button {\n  width: 5.6rem;\n  height: 0.8rem;\n  border-radius: 0.16rem;\n  background: #FFFFFF;\n  border: 0.02rem solid #999999;\n  font-size: 0.3rem;\n  font-family: Microsoft YaHei;\n  font-weight: 400;\n  color: #111111;\n}\n", ""]);
// Exports
module.exports = exports;
